module.exports = __webpack_public_path__ + "./fonts/spotify-regular.ttf";